import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { getSiteStatus, setSiteStatus } from './services/Site_service';

interface SiteState {
  siteEnabled: boolean;
  loading: boolean;
}

const initialState: SiteState = {
  siteEnabled: false,
  loading: true,
};


// Thunk pour récupérer le statut du site
export const fetchSiteStatus = createAsyncThunk(
  'site/fetchSiteStatus',
  async (): Promise<boolean> => {
    const status = await getSiteStatus();
    return status;
  }
);

// Thunk pour mettre à jour le statut du site
export const updateSiteStatus = createAsyncThunk(
  'site/updateSiteStatus',
  async (enabled: boolean): Promise<boolean> => {
    const success = await setSiteStatus(enabled);
    if (success) {
      return enabled;
    } else {
      throw new Error('Échec de la mise à jour du statut du site');
    }
  }
);

const siteSlice = createSlice({
  name: "site",
  initialState,
  reducers: {
    setSiteEnabled(state, action: PayloadAction<boolean>) {
      state.siteEnabled = action.payload;
    },
    toggleSiteEnabled(state) {
      state.siteEnabled = !state.siteEnabled;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSiteStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSiteStatus.fulfilled, (state, action) => {
        state.siteEnabled = action.payload;
        state.loading = false;
      })
      .addCase(fetchSiteStatus.rejected, (state) => {
        state.loading = false;
        // En cas d'erreur, garder la valeur par défaut
      })
      .addCase(updateSiteStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSiteStatus.fulfilled, (state, action) => {
        state.siteEnabled = action.payload;
        state.loading = false;
      })
      .addCase(updateSiteStatus.rejected, (state) => {
        state.loading = false;
        // En cas d'erreur, revenir à l'état précédent
      });
  },
});

export const { setSiteEnabled, toggleSiteEnabled } = siteSlice.actions;
export default siteSlice.reducer;